import translate from '@translate';
import { ConstantsCodeType } from 'src/types/constantsCodes';
import { TableColumnType } from 'src/types/table';

export const allColumns: TableColumnType[] = [
    // {
    //     key: 'ID_ITEM',
    //     label: 'id',
    //     defaultShow: true,
    // },
    {
        key: 'check',
        label: 'check',
        defaultShow: true,
        disableFilter: true,
        disableSort: true,
        customRender: true,
        customStyle: { padding: 0 },
        customStyleHeader: {
            '&.MuiTableCell-root.MuiTableCell-head.MuiTableCell-stickyHeader > span.MuiTableSortLabel-root': {
                padding: 0,
                color: 'red',
            },
        },
    },
    {
        key: 'SECTION',
        label: 'section',
        type: 'select',
        defaultShow: true,
        selectOption: 'SECTIONS',
    },
    // {
    //     key: 'TEXT',
    //     label: 'text',
    //     defaultShow: true,
    // },
    {
        key: 'transaltedText',
        label: 'text',
        defaultShow: true,
    },
    {
        key: 'CREATED_AT',
        label: 'createdAt',
        type: 'dateTime',
        defaultShow: true,
    },
    {
        key: 'WAITING_DAYS',
        label: 'waitingDays',
        type: 'number',
        defaultShow: true,
    },
    {
        key: 'statusText',
        label: 'status',
        defaultShow: true,
        customRender: true,
        customStyle: { padding: '1px 1px 1px 1px' },
    },
    // {
    //     key: 'STATE',
    //     label: 'state',
    //     defaultShow: true,
    // },
];

export const SECTIONS: ConstantsCodeType[] = [
    {
        value: 'ORDER',
        label: translate('tasks.sections.ORDER'),
    },
    {
        value: 'RECEIVING',
        label: translate('tasks.sections.RECEIVING'),
    },
    {
        value: 'CLAIM',
        label: translate('tasks.sections.CLAIM'),
    },
    {
        value: 'PRODUCT',
        label: translate('tasks.sections.PRODUCT'),
    },
];
